import { UserProfileDto, UserRole, ImportPaygapPersonnelDto } from "@green0meter/api-client";
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_PAYGAP } from "../domain";
import { ACTION_GET_CURRENT_COMPANY_PERSONNEL } from "../GetCurrentCompanyPersonnel/useGetCurrentCompanyPersonnel";

import { roleGuard } from "@api";
import { paygapApi } from "@api/services";

export const ACTION_UPDATE_PERSONNEL = "UPDATE_PERSONNEL";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface UpdatePersonnelRequest {
  personnel: unknown[];
  overwrite: boolean;
  companyId: string;
}

const updatePersonnel = async (req: UpdatePersonnelRequest): Promise<unknown> => {
  const response = await paygapApi.paygapControllerImportPersonnel(req as unknown as ImportPaygapPersonnelDto);

  return response.data;
};

export const useUpdatePersonnel = (
  user: UserProfileDto | null,
): {
  updatePersonnel: UseMutateFunction<unknown, Error, UpdatePersonnelRequest, unknown>;
  updatePersonnelEnabled: boolean;
  isSuccessUpdatePersonnel: boolean;
  isPendingUpdatePersonnel: boolean;
  updatePersonnelError: Error | null;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_PAYGAP, ACTION_UPDATE_PERSONNEL],
    mutationFn: enabled ? updatePersonnel : undefined,
    onSuccess: () => {
      // Invalidate personnel data to refetch after update
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PAYGAP, ACTION_GET_CURRENT_COMPANY_PERSONNEL],
      });
    },
  });

  return {
    updatePersonnel: mutate,
    updatePersonnelEnabled: enabled,
    isSuccessUpdatePersonnel: isSuccess,
    isPendingUpdatePersonnel: isPending,
    updatePersonnelError: error,
  };
};
